import { getThemeRefs } from '../../../helpers/themeHelpers';
import globals from '../../globals';
import { refs } from '../inputWrapper';

const globalRefs = getThemeRefs(globals);

export const createBaseButtonSelectionGroupMappings = (vars) => ({
  [vars.hostDirection]: refs.direction,
  [vars.fontFamily]: refs.fontFamily,
  [vars.labelTextColor]: refs.labelTextColor,
  [vars.labelRequiredIndicator]: refs.requiredIndicator,
  [vars.itemsSpacing]: globalRefs.spacing.sm,
  [vars.hostWidth]: refs.width,

  [vars.errorMessageTextColor]: refs.errorMessageTextColor,

  // error message icon
  [vars.errorMessageIcon]: refs.errorMessageIcon,
  [vars.errorMessageIconSize]: refs.errorMessageIconSize,
  [vars.errorMessageIconPadding]: refs.errorMessageIconPadding,
  [vars.errorMessageIconRepeat]: refs.errorMessageIconRepeat,
  [vars.errorMessageIconPosition]: refs.errorMessageIconPosition,
  [vars.errorMessageFontSize]: refs.errorMessageFontSize,
});
